import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { DataColeccionista } from 'app/models/coleccionitas.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class BuscadorColeccionistaService {

    coleccionistas: BehaviorSubject<DataColeccionista[]> = new BehaviorSubject<DataColeccionista[]>([])
    
    //-----------  Properties -----------//
    get coleccionistas$() {
        return this.coleccionistas.asObservable();
    }

    constructor(private apiService: ApiService) { }

    getColeccionista( params:any) {
            
            return new Promise((resolve, reject) => {
                const url = `/coleccionista/buscar`;
                this.apiService.GetMethod(url, params, 'Error al obtener coleccionistas.')
                    .subscribe( (response: any) => {
                        this.coleccionistas.next(response.data);
                        resolve(response.data)
                    })
    
            })
        }
    

    limpiarColeccionistas() {
        this.coleccionistas.next([]);
    }
    
}